import router from "./router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  // 设置页面标题
  document.title = getPageTitle(to.meta.title);

  // 判断用户是否登录
  const hasLogin = sessionStorage.getItem("hasLogin");
  if (hasLogin) {
    if (to.path === "/login") {
      // 如果已经登录，则直接跳转至主页
      next({ path: "/" });
      NProgress.done();
    } else {
      next();
    }
  } else {
    // 没有登录
    const index = whiteList.indexOf(to.path);
    if (index !== -1) {
      // 访问地址在白名单中，则直接进行访问
      next();
    } else {
      // 其他不在白名单中的页面则在登录后进行跳转
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
